import qs from 'query-string';
import axios from 'api/api.config';
import { useMutation } from 'react-query';

export function useExportReportVisitor() {
  return useMutation(({ queryFilter, bodyFilter }) =>
    axios.post(`/api/v1/admin/store-traffic/export?${qs.stringify(queryFilter)}`, bodyFilter).then((res) => res.data)
  );
}
